var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsDateString, IsOptional, IsString } from 'class-validator';
/**
 * Activation state of the calling user's practice (Spec § 9, `GET /activation`).
 *
 * `activated` answers "may the practice dictate right now": a row for the
 * *current* notice version exists. The `textVersion` / `activatedAt` /
 * `activatedByName` triple describes the latest confirmation of any version,
 * so a practice that confirmed v1 while v2 is current reads
 * `activated: false, reconfirmationRequired: true` and still shows who
 * confirmed last.
 */
export class AiDocumentationActivationResponseDto {
    activated;
    textVersion;
    activatedAt;
    activatedByName;
    currentTextVersion;
    reconfirmationRequired;
}
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], AiDocumentationActivationResponseDto.prototype, "activated", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], AiDocumentationActivationResponseDto.prototype, "textVersion", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsDateString(),
    __metadata("design:type", Object)
], AiDocumentationActivationResponseDto.prototype, "activatedAt", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], AiDocumentationActivationResponseDto.prototype, "activatedByName", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AiDocumentationActivationResponseDto.prototype, "currentTextVersion", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], AiDocumentationActivationResponseDto.prototype, "reconfirmationRequired", void 0);
//# sourceMappingURL=ai-documentation-activation-response.dto.js.map